export default function printStatLabel(statSelections, mode) {
  const labels = []
  for (let index = statSelections.length - 1; index >= 0; index--) {
    const statSelection = statSelections[index]
    labels.push(statSelection.label[mode[index] || mode[0]])
  }
  return labels.join(' ')
}
